if (!customElements.get('m-product-views-counter')) {
  customElements.define(
    'm-product-views-counter',
    class MProductViewsCounter extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
        this.onDomChange = () => this.updateLabel();
      }

      connectedCallback() {
        this.labelEl = this.querySelector('[data-product-views-label]');
        this.updateLabel();
        this.observeVisitorsCounter();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
      }

      getVisitorsCount() {
        const sourceSelectors = ['.visitors_counter .shopper-view', '#shopper-view', '.shopper-view'];
        const sources = document.querySelectorAll(sourceSelectors.join(','));

        for (const source of sources) {
          const countNode = source.querySelector('span');
          const text = (countNode || source).textContent.trim();
          const match = text.match(/\d[\d\s.,]*/);

          if (match) {
            return match[0].replace(/[^\d]/g, '');
          }
        }

        return '';
      }

      updateLabel() {
        if (!this.labelEl) return;

        const count = this.getVisitorsCount();

        if (!count) return;

        const template = this.labelEl.dataset.productViewsTemplate || this.labelEl.textContent;
        const label = template.split('[[count]]').join(count).split('{count}').join(count);

        if (this.labelEl.textContent !== label) {
          this.labelEl.textContent = label;
        }

        this.hidden = false;
      }

      observeVisitorsCounter() {
        if (this.observer || !document.body || !window.MutationObserver) return;

        this.observer = new MutationObserver(this.onDomChange);
        this.observer.observe(document.body, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      }
    }
  );
}
